const UserRole = {
  User: 0,
  Moderator: 1,
  Administrator: 99
};

export default UserRole